import React from 'react'
import clsx from 'clsx'
import { Save2 } from 'iconsax-react'
import { useTheme } from '@mui/material'
import Dropdown from '@SonarCX/components/atoms/Dropdown'

const TypeSection = ({ classes, types, values, canEdit, handleChange }) => {
  const theme = useTheme()

  const handleSelect = React.useCallback(
    id => {
      handleChange('type')({ target: { value: id } })
    },
    [handleChange]
  )

  return (
    <div className={clsx(classes.center, classes.label, classes.mobile)}>
      <span className={clsx(classes.center, classes.label)}>
        <Save2
          variant='Bulk'
          size={theme.size.base}
          color={theme.palette.primary.main}
        />
        TASK TYPE
      </span>

      <Dropdown
        options={types.map(({ id }) => id)}
        renderOption={id => types.find(type => type.id === id)?.name || ''}
        selected={values.type}
        onSelect={handleSelect}
        hideAdd
        stringOnly
        disabled={!canEdit}
      >
        <div className={classes.center}>
          <div data-testid='task-type'>
            {types.find(({ id }) => id === values.type)?.name || 'Unassigned'}
          </div>
        </div>
      </Dropdown>
    </div>
  )
}

export default TypeSection
